// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_kr-0";